<td>{{getFechaCreacion(refinamiento.created_at)}}</td>
<td>{{getMotivoEnvio(refinamiento)}}</td>
<td>{{refinamiento.nroAlineacionSuperior}}</td>
<td>{{refinamiento.nroAlineacionInferior}}</td>
<td class="text-right">{{refinamiento.precio_tratamiento_bs ? refinamiento.precio_tratamiento_bs + " Bs":'No'}} </td>
<td>

    {{getEstadoRefinamiento(refinamiento)}}
    <ng-container
        *ngIf="refinamiento.status == estadosRefinamiento.PAGO_INICIAL_ERRONEO|| refinamiento.status == estadosRefinamiento.PAGO_REFINAMIENTO_ERRONEO || refinamiento.status == estadosRefinamiento.REFINAMIENTO_ENTREGADO_RECHAZADO">
        <div><b>Motivo:</b> {{refinamiento.motivo_rechazo}}</div>
    </ng-container>
    <ng-container *ngIf="refinamiento.status == estadosRefinamiento.PAGO_FINAL_REFINAMIENTO_COMPROBADO">
        <div><br/><b>Dirección entrega:</b><br/> {{refinamiento.direccion_entrega}}</div>
        <div *ngIf="refinamiento.latitudEntrega"><a [href]="getGoogleMapsLink()" target="_blank">Ver
                ubicación</a></div>
    </ng-container>
</td>
<td>
    <ng-container *ngIf="isAdmin">
        <a *ngIf="refinamiento.status == estadosRefinamiento.PAGO_INICIAL_ENVIADO"
            [routerLink]="[ '/refinamientos/comprobante-inicial/', refinamiento.id ]" class="btn btn-secondary">Ver
            comprobante inicial</a>
        <a *ngIf="refinamiento.status == estadosRefinamiento.PAGO_FINAL_REFINAMIENTO_REALIZADO"
            [routerLink]="[ '/refinamientos/comprobante-tratamiento/', refinamiento.id ]"
            class="btn btn-secondary btn-block mt-2">Ver
            comprobante tratamiento</a>
        <a *ngIf="refinamiento.status == estadosRefinamiento.FORMULARIO_REFINAMIENTO_ENVIADO || refinamiento.status == estadosRefinamiento.REFINAMIENTO_ENTREGADO_RECHAZADO"
            [routerLink]="[ '/refinamientos/plan/', refinamiento.id ]" class="btn btn-secondary">Ver
            refinamiento solicitado</a>
        <a *ngIf="refinamiento.status == estadosRefinamiento.PAGO_FINAL_REFINAMIENTO_COMPROBADO"
            class="btn btn-secondary btn-block mt-2" (click)="entregarRefinamiento(refinamiento)"
            href="javascript:void(0)">Marcar como entregado</a>
    </ng-container>
    <ng-container *ngIf="isDoctor || isAdmin">
        <div>
            <a *ngIf="refinamiento.status == estadosRefinamiento.REFINAMIENTO_SOLICITADO || refinamiento.status == estadosRefinamiento.PAGO_INICIAL_ERRONEO"
                [routerLink]="[ '/refinamientos/', refinamiento.id ,'cobro']"
                class="btn btn-secondary btn-block mt-2">Realizar
                Pago Inicial</a>
            <a *ngIf="refinamiento.status == estadosRefinamiento.REFINAMIENTO_APROBADO_PAGO_SOLICITADO || refinamiento.status == estadosRefinamiento.PAGO_REFINAMIENTO_ERRONEO"
                [routerLink]="[ '/refinamientos/paso4/', refinamiento.id ]"
                class="btn btn-secondary btn-block mt-2">Realizar
                Pago de Refinamiento</a>
            <a *ngIf="refinamiento.status == estadosRefinamiento.PAGO_INICIAL_VERIFICADO"
                [routerLink]="[ '/refinamientos/plan/', refinamiento.id ]" class="btn btn-secondary btn-block mt-2">Plan
                de Refinamiento</a>
            <a *ngIf="refinamiento.status == estadosRefinamiento.REFINAMIENTO_ENTREGADO"
                class="btn btn-secondary btn-block mt-2"
                [routerLink]="[ '/refinamientos/verresultados/', refinamiento.id ]">Ver
                Resultados</a>
        </div>
        <div>
            <a [routerLink]="[ '/refinamientos/archivos/', refinamiento.id ]" class="btn btn-success btn-block mt-2"><i
                    class="bi bi-eye"></i>
                Ver
                archivos</a>
            <a [routerLink]="[ '/refinamientos/ver/', refinamiento.id ]" class="btn btn-success btn-block mt-2"><i
                    class="bi bi-file-medical"></i> Ver
                Refinamiento</a>
        </div>

    </ng-container>
</td>
<td *ngIf="isAdmin">
    <button class="btn btn-danger btn-block mt-2" (click)="eliminarRefinamiento(refinamiento.id)"><i
            class="bi bi-trash"></i>
        Eliminar</button>
</td>